import Carousel from "@stimulus-components/carousel";

const ANIMATION_DURATION = 300;

export default class extends Carousel {
  connect() {
    super.connect();
  }

  disconnect() {
    super.disconnect();
  }

  left(e) {
    console.log("left");
    this.swiper.slidePrev(ANIMATION_DURATION);
    e.stopPropagation();
    e.preventDefault();
  }

  right(e) {
    console.log("right");
    this.swiper.slideNext(ANIMATION_DURATION);
    e.stopPropagation();
    e.preventDefault();
  }

  get defaultOptions() {
    return {
      loop: true,
    };
  }
}
